// Lucide icon: pencil (https://lucide.dev/icons/pencil)
import { Pencil } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconEdit = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Pencil />
    </IconComponentStyled>
  )
}
